import { FILTER_HAULING_FREIGHT } from '@/lib/constants';
import { getIsApiSegmentTransfer } from '@/lib/transformers/segment/utils/get-is-api-segment-transfer';
import { RouteSequenceApiV4Interface } from '@/types/api-types';

export const getOptionApiHasFreightOnlyVehicles = (option: RouteSequenceApiV4Interface): boolean => {
  const hasFreightOnlyOption = option.segments
    .filter((s) => !getIsApiSegmentTransfer(s))
    .map((segment) => {
      if ('featureSet' in segment) {
        const hauling = segment.featureSet?.vehicle?.hauling || [];
        return hauling.includes(FILTER_HAULING_FREIGHT);
      }
      return false;
    });

  return hasFreightOnlyOption.every((value) => value);
};
